import React from 'react';
import * as S from './style';
import { Label, SpaceDiv, FormItem, BtnContainer } from 'components';
import SelectBox, { Props as SelectBoxProps } from 'components/atoms/SelectBox';
import Input, { Props as InputProps } from 'components/atoms/Input';
import FormProfile, { Props as FormProfileProps } from 'components/molecules/FormProfile';
import BtnNext, { Props as BtnNextProps } from 'components/molecules/BtnNext';
import { LABEL_CARRIERYEAR, TITLE_PROFILE_INFO, LABEL_EMAIL, CAPTION_EMAIL } from 'commons/ZimssaString';

interface Props {
    profileImage: FormProfileProps;
    emailProps: {
        isDirectEmailEntry: boolean;
        email1: InputProps;
        email2: SelectBoxProps;
        email3: InputProps;
    };
    carrierYear: SelectBoxProps;
    btnNext: BtnNextProps;
}

function ProfileRegister({ ...props }: Props): React.ReactElement {
    return (
        <S.ContentsContainer>
            <S.ContentsWrapper>
                <S.TitleWrapper>
                    <S.TitleLabel contents={TITLE_PROFILE_INFO} />
                </S.TitleWrapper>
                <S.ItemContainer>
                    <FormProfile {...props.profileImage} />
                    <FormItem
                        itemType={'ROW'}
                        label={LABEL_EMAIL}
                        caption={<Label contents={CAPTION_EMAIL} color={'blue_900'} fontStyle={'caption'} />}
                        optionalChildren={props.emailProps.isDirectEmailEntry ? <Input {...props.emailProps.email3} /> : null}
                    >
                        <Input inputType={'EMAIL'} {...props.emailProps.email1} />
                        <SelectBox {...props.emailProps.email2} />
                    </FormItem>
                    <FormItem label={LABEL_CARRIERYEAR}>
                        <SelectBox {...props.carrierYear} />
                    </FormItem>
                </S.ItemContainer>
            </S.ContentsWrapper>
            <SpaceDiv height={36} />
            <BtnContainer>
                <BtnNext {...props.btnNext} />
            </BtnContainer>
        </S.ContentsContainer>
    );
}

export default ProfileRegister;
